import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigPayment } from '../../models/FSConfig';

/**
 * Norwegian purchase terms (kjøpsvilkår), shown by TermsComponent when the venue's language is Norwegian.
 * Built on Forbrukertilsynet's standard sales conditions for consumer purchases over the internet, trimmed to food
 * and drink served on the premises. The seller's details come from the venue config; a missing one shows as "–"
 * so no sentence is left half-empty. Only the payment methods the venue offers are named.
 */
@Component({
  selector: 'app-terms-no',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-no.component.html'
})
export class TermsNoComponent {
  @Input() busName: string | null = null;
  @Input() orgNumber: string | null = null;
  @Input() busAddress: string | null = null;
  @Input() email: string | null = null;
  @Input() phone: string | null = null;
  @Input() payment: ConfigPayment | null = null;

  show(value: string | null | undefined): string {
    return value?.trim() ? value : "–";
  }
}
